<template>
  <v-card
      v-if="!isEmpty(mailingAddress)"
      flat column>
    <v-subheader>
      Endereço para Correspondência
    </v-subheader>
    <v-card
        flat
        class="ml-3 px-4 py-2"
        color="grey lighten-5">
      <v-layout column>
            <span>
              {{mailingAddress.responsible_name}},
              {{mailingAddress.cellphone}}
            </span>
        <span>{{mailingAddress.street}},
              {{mailingAddress.number}},
              {{mailingAddress.complement}}
            </span>
        <span>
              {{mailingAddress.city.name}} - {{mailingAddress.federal_unit.name}}
            </span>
        <span>
              {{mailingAddress.zip_code}}
            </span>

      </v-layout>
    </v-card>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash'

export default {
  name: 'ResumeMailingAddress',
  data (){
    return {
      isEmpty
    }
  },
  computed: {
    ...mapGetters('newApplication', ['newApplication']),
    mailingAddress() {
      return this.newApplication.mailingAddress;
    },
  },
};
</script>
